import { useToast } from '@chakra-ui/react';
import { EvaluationEvent } from '@keyops-cep/api-client';
import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getEvaluationEventById,
  refreshEvaluationEventResponses,
} from '../api/evaluation-event.functions';
import i18n from '../utils/i18n';

export const useEvaluationEventById = (eventId: string) => {
  return useQuery<EvaluationEvent | undefined>({
    queryKey: ['evaluation-event-by-id', eventId],
    queryFn: () => getEvaluationEventById(eventId),
    enabled: !!eventId, // only fetch if eventId is truthy
  });
};

export const useRefreshEvaluationEventResponses = (eventId: string) => {
  const toast = useToast();

  return useMutation({
    mutationFn: async () => {
      if (!eventId) {
        throw new Error('No tenantId');
      }

      return await refreshEvaluationEventResponses(eventId);
    },
    onSuccess: (_result) => {
      toast({
        title: i18n.t('evaluationEvent.refreshResponses.successMessage'),
        variant: 'subtle',
        isClosable: true,
        status: 'success',
        position: 'top-right',
      });
    },
    onError: () => {
      toast({
        title: i18n.t('errorComponent.title'),
        description: i18n.t('errorComponent.subTitle'),
        variant: 'subtle',
        isClosable: true,
        status: 'error',
        position: 'top-right',
      });
    },
  });
};
